module.exports = __webpack_public_path__ + "39fa150a35f29871fa67a1570257ae52.pdf";